import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import NotificationService from "../../api/notificationService";
import {INotification} from "./Helper";

export const getNotifications = createAsyncThunk<INotification[]>(`${SliceNames.NOTIFICATION}/getNotifications`,
    async (_, thunkAPI) => {
        try {
            const res = await NotificationService.fetchNotificationsForUser()
            return res.data
        } catch (e) {
            return thunkAPI.rejectWithValue(e)
        }
    })

export const markAllNotificationsAsRead = createAsyncThunk(`${SliceNames.NOTIFICATION}/markAllNotificationsAsRead`,
    async (_, thunkAPI) => {
        try {
            await NotificationService.markAllAsRead()
        } catch (e) {
            return thunkAPI.rejectWithValue(e)
        }
    })